/** @internal */
export const NOOP = () =>
{
    // empty!
};
